module.exports = __webpack_public_path__ + "static/media/vision-contracting.19a7f669.png";